import { render, staticRenderFns } from "./ProductLeadTime.vue?vue&type=template&id=b925a834"
import script from "./ProductLeadTime.vue?vue&type=script&lang=js"
export * from "./ProductLeadTime.vue?vue&type=script&lang=js"
import style0 from "./ProductLeadTime.vue?vue&type=style&index=0&id=b925a834&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports